var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ExperimentMap, FilterParams } from "app/models/filter_form.model";
import merge from "lodash-es/merge";
import omitBy from "lodash-es/omitBy";
import isEqual from "lodash-es/isEqual";
import isObject from "lodash-es/isObject";
import * as moment from 'moment-timezone';
import * as qs from 'clever-qs';
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { HttpClient } from "@angular/common/http";
import { mergeFilterParams } from "../../lib/lib";
import { GroupRefService } from "../../support/group_ref/group_ref.service";
import { map } from 'rxjs/operators';
import { DataProvider2 } from "../../provider/data2.provider";
var FilterFormService = /** @class */ (function () {
    function FilterFormService(router, activatedRoute, _translate, http, groupRef, dp2) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this._translate = _translate;
        this.http = http;
        this.groupRef = groupRef;
        this.dp2 = dp2;
        this.filterParams = new FilterParams();
        this.defaultFilterParams = new FilterParams();
        this.addFilterParams = new FilterParams();
        this.experimentMap = new ExperimentMap();
        this.addFilters = [];
        this.excludeKeys = ['dateType', 'trialStart', 'trialEnd'];
        this.refererTypes = ['first', 'created', 'last', 'paid'];
        this.refExtendedFilterOperators = [
            'equal', 'contains', 'starts', 'ends',
            'regexp', 'empty', 'not equal', 'not contains', 'not start',
            'not end', 'not regexp', 'not empty'
        ];
        this.refGroups = [];
        this.refGroupList = [];
        this.refSourceList = [];
    }
    FilterFormService.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, _b, _c, refGroup, group, refSourceList;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        me = this;
                        _b = me;
                        return [4 /*yield*/, me.groupRef.getGroups().toPromise()];
                    case 1:
                        _b.refGroups = _d.sent();
                        _c = me;
                        return [4 /*yield*/, me.getRefGroupFilterList()];
                    case 2:
                        _c.refGroupList = _d.sent();
                        refGroup = me.filterParams.refGroup;
                        if (!(refGroup && refGroup !== 'all')) return [3 /*break*/, 4];
                        group = me.refGroups.find(function (g) { return g.name === refGroup; });
                        return [4 /*yield*/, me.groupRef.getSources(group.id).toPromise()];
                    case 3:
                        refSourceList = _d.sent();
                        me.refSourceList = refSourceList.map(function (s) { return s.name; });
                        _d.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FilterFormService.prototype.setAddFilterParams = function (addParams) {
        var me = this;
        me.addFilterParams = addParams;
        me.activatedRoute.queryParams.subscribe(function () {
            var params = qs.parse(me.router.url.split('?')[1]);
            // Смерджить дефолты, доп. параметры отчёта и urlHash.
            me.filterParams = merge({}, me.defaultFilterParams, me.addFilterParams);
            me.filterParams = merge({}, me.filterParams, params);
            Object.keys(me.experimentMap).forEach(function (key) {
                if (me.filterParams[key] != '') {
                    me.filterParams.experimentName = key;
                    me.filterParams.experimentValue = me.filterParams[key];
                }
            });
            me.filterParams.dateFilterParams = me.getDateFilterParams(me.filterParams, me.addFilterParams);
            me.renderFilterTags(merge({}, me.addFilterParams, params));
            me.currentUrl = me.router.url;
        });
    };
    FilterFormService.prototype.getPromocodeList = function (fp) {
        return this.dp2.get('/promocode/list', fp);
    };
    /**
     *
     * @param {FilterParams} params
     * @returns {FilterParams}
     */
    FilterFormService.prototype.getDiffParams = function (params) {
        var me = this, defaultFilterParams = me.defaultFilterParams;
        // Оставить только параметры, отличные от дефолтных
        var diff = omitBy(params, function (v, k) { return defaultFilterParams[k] === v; });
        // Дополнительная проверка для объектов
        Object.keys(diff).forEach(function (key) {
            if (isObject(diff[key])) {
                if (isEqual(defaultFilterParams[key], diff[key])) {
                    delete diff[key];
                }
            }
        });
        return diff;
    };
    FilterFormService.prototype.getDateFilterParams = function (params, addFilterParams) {
        // Не знаю почему массив нормально не мерджится
        if (addFilterParams.dateFilters) {
            params.dateFilters = addFilterParams.dateFilters;
        }
        params.dateFilters.forEach(function (type) {
            if (typeof params.dateFilterParams[type] === 'undefined') {
                params.dateFilterParams[type] = {
                    start: '',
                    end: '',
                    type: 'all'
                };
            }
        });
        return params.dateFilterParams;
    };
    FilterFormService.prototype.getApplyFilters = function (filterParam) {
        var me = this, otherFilters = {};
        /** otherFilters
         * Проход по addFilterParams и поиск изменений в текущих фильтрах.
         * Если текущий фильтр отличается от этого же фильтра, заданного в addFilterParams, то потом надо его намерджить после всех манипуляций.
         * Иначе изменения будут затерты настройками из addFilterParams.
         *
         * Связано с проблемой, когда не могли установить фильтр на userType = all в отчётах (например reg_day).
         */
        Object.keys(this.addFilterParams).forEach(function (el) {
            if (filterParam[el] != me.addFilterParams[el]) {
                otherFilters[el] = filterParam[el];
            }
        });
        var params = merge({}, this.getDiffParams(filterParam), otherFilters);
        if (params.dateFilterParams) {
            Object.keys(params.dateFilterParams).forEach(function (dateType) {
                if (params.dateFilterParams[dateType].type != 'all' && params.dateFilterParams[dateType].type != 'other') {
                    var dateParams = me.filterBuilder(params.dateFilterParams[dateType].type);
                    params.dateFilterParams[dateType] = {
                        start: dateParams.start || '',
                        end: dateParams.end || '',
                        type: params.dateFilterParams[dateType].type
                    };
                }
                else if (params.dateFilterParams[dateType].type == 'all') {
                    delete params.dateFilterParams[dateType];
                }
            });
        }
        delete params.dateFilters;
        delete params.isRegDay;
        delete params.isBilling;
        delete params.isDomainBilling;
        delete params.isTemplateTag;
        delete params.isExpiredPaid;
        delete params.isPromocode;
        delete params.isExpiredDomains;
        delete params.isNotice;
        delete params.experimentName;
        delete params.experimentValue;
        delete params.dateTime;
        if (params.refGroup) {
            params.refGroup = encodeURIComponent(params.refGroup);
        }
        if (params.refSource) {
            params.refSource = encodeURIComponent(params.refSource);
        }
        return params;
    };
    FilterFormService.prototype._a = function (key) {
        return this._translate.instant('adminstat.' + key);
    };
    // Вывести список активных фильтров
    FilterFormService.prototype.renderFilterTags = function (_params) {
        var me = this;
        this.filterPanelParams = {};
        var params = merge({}, _params);
        delete params.allowList;
        delete params.dateFilters;
        delete params.isRegDay;
        delete params.isBilling;
        delete params.isTemplateTag;
        delete params.isExpiredPaid;
        delete params.isPromocode;
        delete params.isAccessor;
        delete params.isBillingAllow;
        delete params.isDomainBilling;
        delete params.refererFilterType;
        delete params.dateType;
        Object.keys(params).forEach(function (key) {
            if (me.excludeKeys.includes(key)) {
                return true;
            }
            if (key === 'refExtendedFilters') {
                me.filterPanelParams[me._a('filterForm.' + key)] = '';
                params[key].forEach(function (rule) {
                    if (!rule.condition && rule.refererType) {
                        me.filterPanelParams[me._a('filterForm.' + key)] += me._a('filterForm.' + rule.refererType) + ' - ' + rule.searchByMarkUtm + ' ' + me._a('users.group_ref_new.' + rule.searchByMarkRule) + ' ' + rule.refererSearchValue;
                    }
                    else {
                        me.filterPanelParams[me._a('filterForm.' + key)] += ' ' + me._a('filterForm.' + rule.condition) + ' ';
                    }
                });
            }
            else if (key === 'dateFilterParams') {
                Object.keys(params[key]).forEach(function (dateFilter) {
                    me.filterPanelParams[me._a('filterForm.' + dateFilter)] = params[key][dateFilter].start + ' - ' + params[key][dateFilter].end;
                    if (params[key][dateFilter].type != 'other') {
                        me.filterPanelParams[me._a('filterForm.' + dateFilter)] += ' (' + me._a('common.interval.' + params[key][dateFilter].type) + ')';
                    }
                });
            }
            else if (key == 'addedWidget' || key == 'actionCount' || key == 'promoProgress') {
                me.filterPanelParams[me._a('filterForm.' + key)] = me._a('filterForm.start') + ' ' + me._a('filterForm.' + params[key].gt) + ' - ' + me._a('filterForm.end') + ' ' + me._a('filterForm.' + params[key].lt);
            }
            else if (typeof params[key] == 'number' || key == 'domainZone' || key == 'email' || key == 'emailOther' || key == 'regFilter' || key == 'subject' || key == 'category' || key == 'serverAlias' || key === 'realSubject') {
                me.filterPanelParams[me._a('filterForm.' + key)] = params[key];
            }
            else if (key == 'refUrl') {
                me.filterPanelParams[me._a('filterForm.' + key)] = params[key];
            }
            else if (key === 'paidStatus') {
                var str = '';
                if (params.paidStatus === 'trial') {
                    var trialStart = params.trialStart, trialEnd = params.trialEnd, label = me._a('filterForm.trial day'), startLabel = me._a('filterForm.start'), endLabel = me._a('filterForm.end');
                    if (trialStart && trialEnd) {
                        str = label + " " + startLabel + " " + trialStart + " " + endLabel + " " + trialEnd;
                    }
                    else if (trialStart) {
                        str = label + " " + startLabel + " " + trialStart;
                    }
                    else if (trialEnd) {
                        str = label + " " + endLabel + " " + trialEnd;
                    }
                    else {
                        str = me._a('filterForm.paidStatusList.' + params[key]);
                    }
                }
                else {
                    str = me._a('filterForm.paidStatusList.' + params[key]);
                }
                me.filterPanelParams[me._a('filterForm.' + key)] = str;
            }
            else if (key === 'source') {
                me.filterPanelParams[me._a('common.' + key)] = me._a('common.clusters.' + params[key]);
            }
            else if (key === 'page') {
                me.filterPanelParams[me._a('filterForm.' + key)] = params[key];
            }
            else if (key === 'lang') {
                me.filterPanelParams[me._a('filterForm.' + key)] = params[key];
            }
            else {
                me.filterPanelParams[me._a('filterForm.' + key)] = me._a('filterForm.' + params[key]);
            }
        });
        delete this.filterPanelParams.allowList;
        delete this.filterPanelParams.dateFilters;
        delete this.filterPanelParams.isRegDay;
        delete this.filterPanelParams.isBilling;
        delete this.filterPanelParams.isTemplateTag;
        delete this.filterPanelParams.isExpiredPaid;
        delete this.filterPanelParams.isPromocode;
        delete this.filterPanelParams.isAccessor;
        delete this.filterPanelParams.isBillingAllow;
        delete this.filterPanelParams.isDomainBilling;
        delete this.filterPanelParams.refererFilterType;
        delete this.filterPanelParams.dateType;
    };
    FilterFormService.prototype.filterBuilder = function (type) {
        var milisecByDay = 24 * 3600 * 1000;
        var query = {};
        var start = new Date();
        var end = new Date();
        if (type) {
            switch (type) {
                case 'all':
                    start = null;
                    end = null;
                    break;
                case 'yesterday':
                    end = moment(new Date()).date(moment(new Date()).date() - 1).toDate();
                    start = moment(end).toDate();
                    break;
                case 'now':
                    end = new Date();
                    start = new Date();
                    break;
                case 'last7day':
                    end = new Date();
                    start = moment(end.getTime() - 7 * milisecByDay).toDate();
                    break;
                case 'last30day':
                    end = new Date();
                    start = moment(end.getTime() - 30 * milisecByDay).toDate();
                    break;
                case 'prevWeek':
                    end = moment(new Date()).subtract(1, 'weeks').endOf('isoWeek').toDate();
                    start = moment(end).subtract(0, 'weeks').startOf('isoWeek').toDate();
                    break;
                case 'prevMonth':
                    end = moment(new Date()).subtract(1, 'months').endOf('month').toDate();
                    start = moment(end).subtract(0, 'months').startOf('month').toDate();
                    break;
                case 'allTime':
                    end = moment().endOf('day').toDate();
                    start = moment('2015-03-01 00:00:00').toDate();
                    break;
                case 'other':
                    if (moment(end, "DD-MM-YYYY").isValid()) {
                        end = moment(end, "DD-MM-YYYY").toDate();
                    }
                    else {
                        end = new Date();
                    }
                    if (moment(start, "DD-MM-YYYY").isValid()) {
                        start = moment(start, "DD-MM-YYYY").toDate();
                    }
                    else {
                        start = new Date();
                    }
                    break;
                default:
                    // 1;
                    break;
            }
            if (start && end) {
                // Не выравниваем границу дня для "предыдущая неделя" и " предыдущий месяц"
                if (['lastWeek', 'lastMonth'].indexOf(type) > -1) {
                    query['start'] = moment(start).format("DD-MM-YYYY");
                    query['end'] = moment(end).format("DD-MM-YYYY");
                }
                else {
                    query['start'] = moment(start).startOf('day').format("DD-MM-YYYY");
                    query['end'] = moment(end).endOf('day').format("DD-MM-YYYY");
                }
            }
        }
        else {
            delete query['start'];
            delete query['end'];
        }
        return query;
    };
    FilterFormService.prototype.getFilterParams = function () {
        return this.filterParams;
    };
    FilterFormService.prototype.getCopyFilterParams = function (params) {
        return mergeFilterParams(this.filterParams, params);
    };
    FilterFormService.prototype.getDatesFilter = function (dateType, borderName) {
        var dateFilter = this.filterParams.dateFilterParams[dateType] || {};
        if (borderName) {
            return dateFilter[borderName];
        }
        return dateFilter;
    };
    FilterFormService.prototype.getCityList = function (ccode, searchQuery) {
        if (ccode === void 0) { ccode = 'ru'; }
        var params = { ccode: ccode };
        if (searchQuery) {
            params['searchQuery'] = searchQuery;
        }
        return this.dp2.get('/cities', params);
    };
    FilterFormService.prototype.getRefGroupFilterList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var refGroupList;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.groupRef.getGroups().toPromise()];
                    case 1:
                        refGroupList = _b.sent();
                        return [2 /*return*/, ['all', 'Direct', 'Referral', 'Ungrouped'].concat(refGroupList.map(function (g) { return g.name; }))];
                }
            });
        });
    };
    FilterFormService.prototype.getRefSourceFilterList = function (refGroup) {
        return __awaiter(this, void 0, void 0, function () {
            var me, refGroups, group, refSourceList;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        me = this;
                        return [4 /*yield*/, me.groupRef.getGroups().toPromise()];
                    case 1:
                        refGroups = _b.sent();
                        group = refGroups.find(function (g) { return g.name === refGroup; });
                        return [4 /*yield*/, me.groupRef.getSources(group.id).toPromise()];
                    case 2:
                        refSourceList = _b.sent();
                        return [2 /*return*/, refSourceList.map(function (s) { return s.name; })];
                }
            });
        });
    };
    FilterFormService.prototype.setReportGUID = function () {
        this._reportGUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };
    Object.defineProperty(FilterFormService.prototype, "reportGUID", {
        get: function () {
            if (!this._reportGUID) {
                this.setReportGUID();
            }
            return this._reportGUID;
        },
        enumerable: true,
        configurable: true
    });
    FilterFormService.prototype.getReportQueries = function () {
        return this.dp2.get("/report_queries/" + this._reportGUID).pipe(map(function (r) { return r; }));
    };
    FilterFormService.prototype.changeRefererType = function (type) {
        var me = this;
        if (type == me.filterParams.refererFilterType) {
            return true;
        }
        me.filterParams.refererFilterType = type;
        if (type == 'extended') {
            me.filterParams.refGroup = 'all';
            me.filterParams.refSource = 'all';
            me.filterParams.refExtendedFilters.push({
                refererType: me.filterParams.refererType || 'first',
                searchByMarkUtm: 'utm_source',
                searchByMarkRule: 'equal',
                refererSearchValue: ''
            });
        }
        else if (type == 'simple') {
            me.filterParams.refExtendedFilters = [];
        }
    };
    FilterFormService.prototype.onRefGroupSelect = function (refGroup) {
        return __awaiter(this, void 0, void 0, function () {
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, this.getRefSourceFilterList(refGroup)];
                    case 1:
                        _b.refSourceList = _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FilterFormService.prototype.reset = function () {
        this.filterParams = new FilterParams();
        this.filterParams = merge({}, this.filterParams, this.addFilterParams);
        this.filterParams.dateFilterParams = this.getDateFilterParams(this.filterParams, this.addFilterParams);
    };
    return FilterFormService;
}());
export { FilterFormService };
